import React, { useState, useEffect, useMemo, useRef } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import axios from "axios";
import moment from "moment";
import { Modal, ModalBody } from "reactstrap";
import {
  FiSearch,
  FiMapPin,
  FiSliders,
  FiCheckCircle,
  FiClock,
  FiPhoneCall,
  FiUsers,
  FiArrowLeft,
  FiShield,
  FiX,
  FiEye,
  FiPlus,
  FiChevronDown,
  FiChevronUp,
  FiFilter,
  FiRotateCcw,
} from "react-icons/fi";
import { FaStar, FaStarHalfAlt, FaWhatsapp } from "react-icons/fa";
import { RxCross2 } from "react-icons/rx";
import { Baseurl } from "../../config/BaseUrl";
import PropertyDetailsModel from "../home/latestProperty/PropertyDetailsModel";
import Footer from "../../components/layouts/Footer";
import { setleadesSearchObjects } from "../../redux/search/SearchSlice";
import { setModelShow } from "../../redux/athentication/Athentication";
import Login from "../../components/Logins/Login";
import Registration from "../../components/Logins/Registration";
import "./LeadSearchResultNew.css";

const LeadsearchResult = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { leadesSearchObjects } = useSelector((state) => state.Search);
  const { loginData, isAuth, modelShow } = useSelector((store) => store.Athentication);

  // Search Bar Header State
  const searchWrapRef = useRef(null);
  const [headerSearchText, setHeaderSearchText] = useState("");
  const [isCatDropdownOpen, setIsCatDropdownOpen] = useState(false);
  const [headerCategory, setHeaderCategory] = useState("Buy");
  const [headerSuggestions, setHeaderSuggestions] = useState([]);
  const [showSuggestions, setShowSuggestions] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  // Active Lead Search Configuration
  const [activeSearch, setActiveSearch] = useState(() => {
    if (
      leadesSearchObjects &&
      typeof leadesSearchObjects === "object" &&
      Array.isArray(leadesSearchObjects.searchArray) &&
      leadesSearchObjects.searchArray.length > 0
    ) {
      return leadesSearchObjects;
    }
    try {
      const stored = localStorage.getItem("leadesSearchObjects");
      if (stored) return JSON.parse(stored);
    } catch (e) { }
    return {
      selectSupcat: "Residential",
      selectbuyrent: "Sell",
      searchArray: ["Hyderabad"],
    };
  });

  // Leads Data
  const [fetchallLeads, setFetchallLeads] = useState([]);
  const [loadingdata, setLoadingdata] = useState(true);

  // Filter States
  const [selectedBhk, setSelectedBhk] = useState("all");
  const [possessionFilter, setPossessionFilter] = useState("all");
  const [decisionTime, setDecisionTime] = useState("");
  const [onlyNRI, setOnlyNRI] = useState(false);
  const [activeTypeTab, setActiveTypeTab] = useState(activeSearch?.selectSupcat || "Residential");

  // Mobile Filter Drawer
  const [mobileFilterOpen, setMobileFilterOpen] = useState(false);

  // Contact Modal
  const [modal2, setModal2] = useState(false);
  const [singleProperty, setSingleProperty] = useState(null);

  const toggle2 = () => setModal2(!modal2);
  const closePropDetailModal = () => setModal2(false);

  // Pre-cached popular localities in Hyderabad for fallback suggestions
  const POPULAR_SUGGESTIONS = [
    "Hyderabad",
    "Gachibowli",
    "Madhapur",
    "Hitec City",
    "Kondapur",
    "Kokapet",
    "Tellapur",
    "Nallagandla",
    "Banjara Hills",
    "Jubilee Hills",
    "Manikonda",
    "Miyapur",
    "Kukatpally",
  ];

  // Verified Leads Sample Data Fallback
  const getSampleLeads = (locationName = "Hyderabad", category = "Sell") => [
    {
      _id: "sample_1",
      propertyName: `Prestige Tranquil, ${locationName}`,
      category: category === "Rent" ? "Rent" : "Buy",
      city: "Hyderabad",
      locality: locationName,
      price: category === "Rent" ? "₹ 45,000 / mo" : "₹ 1.25 Crore",
      noofBedrooms: "3",
      createdAt: new Date(Date.now() - 3600000 * 3),
      userName: "K. Venkatesh",
      userMobile: "+91 98490 *****",
      rating: "5.0",
      possession: "Immediate",
      callTime: "Evening 5 PM - 8 PM",
      isNRI: false,
    },
    {
      _id: "sample_2",
      propertyName: `My Home Bhooja, ${locationName}`,
      category: category === "Rent" ? "Rent" : "Buy",
      city: "Hyderabad",
      locality: locationName,
      price: category === "Rent" ? "₹ 65,000 / mo" : "₹ 2.80 Crore",
      noofBedrooms: "3",
      createdAt: new Date(Date.now() - 3600000 * 12),
      userName: "S. Rao (IT Professional)",
      userMobile: "+91 94401 *****",
      rating: "5.0",
      possession: "Within 3 Months",
      callTime: "Any Time",
      isNRI: false,
    },
    {
      _id: "sample_3",
      propertyName: `Aparna Sarovar Zenith, ${locationName}`,
      category: category === "Rent" ? "Rent" : "Buy",
      city: "Hyderabad",
      locality: locationName,
      price: category === "Rent" ? "₹ 35,000 / mo" : "₹ 95 Lacs",
      noofBedrooms: "2",
      createdAt: new Date(Date.now() - 3600000 * 24),
      userName: "Rajesh Kumar",
      userMobile: "+91 97000 *****",
      rating: "5.0",
      possession: "Immediate",
      callTime: "Morning 10 AM - 1 PM",
      isNRI: false,
    },
    {
      _id: "sample_4",
      propertyName: `Lodha Bellezza, ${locationName}`,
      category: category === "Rent" ? "Rent" : "Buy",
      city: "Hyderabad",
      locality: locationName,
      price: category === "Rent" ? "₹ 80,000 / mo" : "₹ 3.50 Crore",
      noofBedrooms: "4",
      createdAt: new Date(Date.now() - 3600000 * 48),
      userName: "P. Sharma (NRI Investor)",
      userMobile: "+91 99899 *****",
      rating: "5.0",
      possession: "Within 6 Months",
      callTime: "Any Time",
      isNRI: true,
    },
    {
      _id: "sample_5",
      propertyName: `Incor PBEL City, ${locationName}`,
      category: category === "Rent" ? "Rent" : "Buy",
      city: "Hyderabad",
      locality: locationName,
      price: category === "Rent" ? "₹ 30,000 / mo" : "₹ 88 Lacs",
      noofBedrooms: "2",
      createdAt: new Date(Date.now() - 3600000 * 72),
      userName: "Anand Verma",
      userMobile: "+91 98855 *****",
      rating: "5.0",
      possession: "Immediate",
      callTime: "Any Time",
      isNRI: false,
    },
  ];

  // Fetch Suggestions as user types in Header
  useEffect(() => {
    if (!headerSearchText || headerSearchText.trim().length < 2) {
      setHeaderSuggestions([]);
      return;
    }
    const q = headerSearchText.trim().toLowerCase();
    const filtered = POPULAR_SUGGESTIONS.filter((loc) =>
      loc.toLowerCase().includes(q)
    );
    setHeaderSuggestions(filtered);
  }, [headerSearchText]);

  // Click outside listener for header search dropdowns
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (searchWrapRef.current && !searchWrapRef.current.contains(e.target)) {
        setShowSuggestions(false);
        setIsCatDropdownOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  // Fetch Leads for Active Search
  useEffect(() => {
    let isCancelled = false;
    setLoadingdata(true);

    const localities =
      Array.isArray(activeSearch?.searchArray) && activeSearch.searchArray.length > 0
        ? activeSearch.searchArray
        : ["Hyderabad"];

    const fetchAllData = async () => {
      let combined = [];
      try {
        const promises = [];
        for (let i = 0; i < localities.length; i++) {
          const loc = localities[i];
          promises.push(
            axios.get(`${Baseurl}/api/v1/viewed/leadesbycity/${encodeURIComponent(loc)}`)
          );
          promises.push(
            axios.get(`${Baseurl}/api/v1/viewed/leadesbylocality/${encodeURIComponent(loc)}`)
          );
        }

        const results = await Promise.allSettled(promises);
        results.forEach((res) => {
          if (res.status === "fulfilled" && res.value?.data?.success) {
            const list =
              res.value.data.leadesBycity || res.value.data.leadesByLocality || [];
            if (Array.isArray(list)) {
              combined = [...combined, ...list];
            }
          }
        });
      } catch (err) { }

      if (!isCancelled) {
        if (combined.length === 0) {
          combined = getSampleLeads(
            localities[0] || "Hyderabad",
            activeSearch?.selectbuyrent || "Sell"
          );
        }
        setFetchallLeads(combined);
        setLoadingdata(false);
      }
    };

    fetchAllData();
    return () => {
      isCancelled = true;
    };
  }, [activeSearch]);

  // Filter Leads
  const filteredLeads = useMemo(() => {
    return fetchallLeads.filter((lead) => {
      // BHK filter
      if (selectedBhk !== "all") {
        const leadBhk = String(lead.noofBedrooms || "").trim();
        if (selectedBhk === "4" && Number(leadBhk) < 4) return false;
        if (selectedBhk !== "4" && leadBhk !== selectedBhk) return false;
      }

      // NRI filter
      if (onlyNRI && !lead.isNRI) return false;

      // Possession filter
      if (possessionFilter === "immediate") {
        const poss = (lead.possession || "").toLowerCase();
        if (!poss.includes("immediate") && !poss.includes("ready")) return false;
      } else if (possessionFilter === "3months") {
        const poss = (lead.possession || "").toLowerCase();
        if (!poss.includes("3 month") && !poss.includes("immediate")) return false;
      }

      return true;
    });
  }, [fetchallLeads, selectedBhk, onlyNRI, possessionFilter]);

  // Header Search Submission
  const handleHeaderSearchSubmit = (localityToSet) => {
    const loc = (localityToSet || headerSearchText).trim();
    if (!loc) return;

    const updatedArray = [loc];
    const newConfig = {
      ...activeSearch,
      selectSupcat: activeTypeTab,
      selectbuyrent: headerCategory === "Rent" ? "Rent" : "Sell",
      searchArray: updatedArray,
    };

    setActiveSearch(newConfig);
    setHeaderSearchText("");
    setShowSuggestions(false);
    dispatch(setleadesSearchObjects(newConfig));
    try {
      localStorage.setItem("leadesSearchObjects", JSON.stringify(newConfig));
    } catch (e) { }
  };

  // Add locality to chips
  const addLocalityChip = (locName) => {
    if (!locName) return;
    const current = activeSearch?.searchArray || ["Hyderabad"];
    if (!current.includes(locName)) {
      const updated = [locName, ...current];
      const newConfig = { ...activeSearch, searchArray: updated };
      setActiveSearch(newConfig);
      dispatch(setleadesSearchObjects(newConfig));
      try {
        localStorage.setItem("leadesSearchObjects", JSON.stringify(newConfig));
      } catch (e) { }
    }
    setHeaderSearchText("");
    setShowSuggestions(false);
  };

  // Remove locality chip
  const removeLocalityChip = (locName) => {
    const current = activeSearch?.searchArray || ["Hyderabad"];
    let updated = current.filter((item) => item !== locName);
    if (updated.length === 0) updated = ["Hyderabad"];
    const newConfig = { ...activeSearch, searchArray: updated };
    setActiveSearch(newConfig);
    dispatch(setleadesSearchObjects(newConfig));
    try {
      localStorage.setItem("leadesSearchObjects", JSON.stringify(newConfig));
    } catch (e) { }
  };

  // Clear all filters
  const resetAllFilters = () => {
    setSelectedBhk("all");
    setPossessionFilter("all");
    setDecisionTime("");
    setOnlyNRI(false);
  };

  // Active filters count
  const activeFiltersCount =
    (selectedBhk !== "all" ? 1 : 0) +
    (possessionFilter !== "all" ? 1 : 0) +
    (onlyNRI ? 1 : 0);

  // Handle contact click and open property details modal
  const handleViewContact = async (lead) => {
    if (!lead) return;

    if (lead.propertyName) {
      try {
        const url = `${Baseurl}/api/v1/property/${encodeURIComponent(
          lead.propertyName
        )}`;
        const fetchProp = await axios.get(url);
        if (fetchProp.data?.success && fetchProp.data.property) {
          setSingleProperty(fetchProp.data.property);
          setModal2(true);
          return;
        }
      } catch (err) { }
    }

    setSingleProperty({
      apartment: lead.propertyName || "Verified Residence",
      locality: lead.locality || "Hyderabad",
      city: lead.city || "Hyderabad",
      price: lead.price || "₹ 1.25 Crore",
      noofBedrooms: lead.noofBedrooms || 3,
      carpetArea: "1,450 sq.ft.",
      category: lead.category || "Buy",
      buyerName: lead.userName || lead.buyerName || "Verified Buyer",
      phone: lead.userMobile || lead.phone || "+91 98490 *****",
      postUserName: lead.userName || "Verified Buyer",
      postUserMobile: lead.userMobile || "+91 98490 *****",
      postUserEmail: lead.userEmail || "buyer@ewrealty.com",
    });
    setModal2(true);
  };

  const handleWhatsApp = (lead) => {
    const text = `Hello, I saw your buyer requirement for ${lead.propertyName || "property"
      } in ${lead.locality || "Hyderabad"}. I have verified properties on EwRealty!`;
    const url = `https://api.whatsapp.com/send?text=${encodeURIComponent(text)}`;
    window.open(url, "_blank");
  };

  return (
    <div className="mgh-lsr-page">
      {/* ================= 1. Dedicated Search Header ================= */}
      <header className="mgh-lsr-header">
        {/* Left: Brand Logo */}
        <Link to="/" className="mgh-lsr-logo">
          <img
            src="/assets/images/logo4.png"
            alt="EwRealty"
            className="mgh-lsr-logo-img"
          />
        </Link>

        {/* Center: Search Bar with Buy/Rent Dropdown, Locality Chip, Input */}
        <div className="mgh-lsr-header-search" ref={searchWrapRef}>
          {/* Category Dropdown */}
          <div className="mgh-lsr-search-dropdown-wrap">
            <button
              type="button"
              className="mgh-lsr-search-cat-btn"
              onClick={() => setIsCatDropdownOpen(!isCatDropdownOpen)}
            >
              <span>{headerCategory}</span>
              {isCatDropdownOpen ? <FiChevronUp /> : <FiChevronDown />}
            </button>
            {isCatDropdownOpen && (
              <div className="mgh-lsr-search-cat-menu">
                <div
                  className={`mgh-lsr-search-menu-item ${headerCategory === "Buy" ? "active" : ""
                    }`}
                  onClick={() => {
                    setHeaderCategory("Buy");
                    setIsCatDropdownOpen(false);
                  }}
                >
                  For Buy
                </div>
                <div
                  className={`mgh-lsr-search-menu-item ${headerCategory === "Rent" ? "active" : ""
                    }`}
                  onClick={() => {
                    setHeaderCategory("Rent");
                    setIsCatDropdownOpen(false);
                  }}
                >
                  For Rent
                </div>
              </div>
            )}
          </div>

          <div className="mgh-lsr-search-divider" />

          {/* Active Primary Locality Chip */}
          {activeSearch.searchArray && activeSearch.searchArray.length > 0 && (
            <div className="mgh-lsr-search-chip">
              <span>{activeSearch.searchArray[0]}</span>
              <RxCross2
                onClick={(e) => {
                  e.stopPropagation();
                  removeLocalityChip(activeSearch.searchArray[0]);
                }}
                title="Remove location"
              />
            </div>
          )}

          {/* Search Input */}
          <input
            type="text"
            className="mgh-lsr-search-input"
            placeholder='Search "Locality in Hyderabad"'
            value={headerSearchText}
            onChange={(e) => {
              setHeaderSearchText(e.target.value);
              setShowSuggestions(true);
            }}
            onFocus={() => {
              if (headerSearchText.trim().length >= 2) setShowSuggestions(true);
            }}
            onKeyDown={(e) => {
              if (e.key === "Enter") handleHeaderSearchSubmit();
            }}
          />

          {/* Search Submit Button */}
          <button
            type="button"
            className="mgh-lsr-search-submit"
            onClick={() => handleHeaderSearchSubmit()}
            title="Search Leads"
          >
            <FiSearch size={15} />
          </button>

          {/* Suggestions Dropdown */}
          {showSuggestions && headerSuggestions.length > 0 && (
            <div className="mgh-lsr-suggestions-box">
              {headerSuggestions.map((loc, idx) => (
                <div
                  key={idx}
                  className="mgh-lsr-suggestion-item"
                  onClick={() => {
                    addLocalityChip(loc);
                    handleHeaderSearchSubmit(loc);
                  }}
                >
                  <FiMapPin size={14} />
                  <span>{loc}, Hyderabad</span>
                </div>
              ))}
            </div>
          )}
        </div>

        {/* Right: Credits Badge, Post Property, User Profile, Mobile Menu */}
        <div className="mgh-lsr-header-right">
          {/* Credits Counter Pill */}
          <div className="mgh-lsr-credits-pill">
            <span className="mgh-lsr-credits-text">
              🪙 {loginData?.creadits || 0} Leads
            </span>
            <Link to="/BossPlans" className="mgh-lsr-getcredits-link">
              Get Credits
            </Link>
          </div>

          {/* Post Property Free Button */}
          <Link to="/postproperty" className="mgh-lsr-post-btn">
            <FiPlus size={13} />
            <span className="mgh-lsr-post-full">Post Property</span>
            <span className="mgh-lsr-post-short">Post</span>
            <span className="mgh-lsr-post-badge">FREE</span>
          </Link>

          {/* User Button */}
          {isAuth ? (
            <Link to="/dashboard" className="mgh-lsr-user-btn">
              <span>{loginData?.name ? loginData.name.split(" ")[0] : "Account"}</span>
              <FiChevronDown size={14} />
            </Link>
          ) : (
            <button
              type="button"
              className="mgh-lsr-user-btn"
              onClick={() => dispatch(setModelShow(true))}
            >
              <span>Sign In</span>
            </button>
          )}

          {/* Mobile Hamburger Toggle */}
          <button
            type="button"
            className="mgh-lsr-hamburger"
            onClick={() => setMobileFilterOpen(true)}
            aria-label="Toggle Filters"
          >
            <span></span>
            <span></span>
            <span></span>
          </button>
        </div>
      </header>

      {/* ================= 2. Main Page Content (2 Columns) ================= */}
      <main className="mgh-lsr-main">
        {/* Left Sidebar Filter Panel (Desktop Sticky) */}
        <aside className="mgh-lsr-sidebar">
          <div className="mgh-lsr-sidebar-header">
            <span className="mgh-lsr-sidebar-title">
              <FiSliders /> Filters {activeFiltersCount > 0 && `(${activeFiltersCount})`}
            </span>
            {activeFiltersCount > 0 && (
              <button
                type="button"
                className="mgh-lsr-sidebar-reset"
                onClick={resetAllFilters}
              >
                Clear All
              </button>
            )}
          </div>

          {/* Active Chips */}
          <div className="mgh-lsr-active-filters-wrap">
            {(activeSearch?.searchArray || ["Hyderabad"]).map((loc, idx) => (
              <span className="mgh-lsr-active-pill" key={idx}>
                <FiMapPin size={11} /> {loc}
                {activeSearch.searchArray.length > 1 && (
                  <RxCross2 onClick={() => removeLocalityChip(loc)} />
                )}
              </span>
            ))}
            <span className="mgh-lsr-active-pill">
              {activeSearch?.selectbuyrent === "Rent" ? "For Rent" : "For Buy"}
            </span>
            {selectedBhk !== "all" && (
              <span className="mgh-lsr-active-pill">
                {selectedBhk} BHK
                <RxCross2 onClick={() => setSelectedBhk("all")} />
              </span>
            )}
          </div>

          {/* Category Type */}
          <div className="mgh-lsr-filter-group">
            <h4 className="mgh-lsr-filter-label">Category</h4>
            <div className="mgh-lsr-pills-row">
              {["Residential", "Commercial"].map((type) => (
                <button
                  key={type}
                  type="button"
                  className={`mgh-lsr-choice-pill ${activeTypeTab === type ? "active" : ""
                    }`}
                  onClick={() => setActiveTypeTab(type)}
                >
                  {type}
                </button>
              ))}
            </div>
          </div>

          {/* Bedrooms (BHK) Filter */}
          <div className="mgh-lsr-filter-group">
            <h4 className="mgh-lsr-filter-label">Bedrooms (BHK)</h4>
            <div className="mgh-lsr-pills-row">
              {[
                { label: "All", val: "all" },
                { label: "1 BHK", val: "1" },
                { label: "2 BHK", val: "2" },
                { label: "3 BHK", val: "3" },
                { label: "4+ BHK", val: "4" },
              ].map((item) => (
                <button
                  key={item.val}
                  type="button"
                  className={`mgh-lsr-choice-pill ${selectedBhk === item.val ? "active" : ""
                    }`}
                  onClick={() => setSelectedBhk(item.val)}
                >
                  {item.label}
                </button>
              ))}
            </div>
          </div>

          {/* Possession Timeline */}
          <div className="mgh-lsr-filter-group">
            <h4 className="mgh-lsr-filter-label">Possession Timeline</h4>
            <div className="mgh-lsr-options-stack">
              <label className="mgh-lsr-check-row">
                <input
                  type="radio"
                  name="possession"
                  checked={possessionFilter === "all"}
                  onChange={() => setPossessionFilter("all")}
                />
                <span>All Timelines</span>
              </label>
              <label className="mgh-lsr-check-row">
                <input
                  type="radio"
                  name="possession"
                  checked={possessionFilter === "immediate"}
                  onChange={() => setPossessionFilter("immediate")}
                />
                <span>Ready / Immediate</span>
              </label>
              <label className="mgh-lsr-check-row">
                <input
                  type="radio"
                  name="possession"
                  checked={possessionFilter === "3months"}
                  onChange={() => setPossessionFilter("3months")}
                />
                <span>Within 3 Months</span>
              </label>
            </div>
          </div>

          {/* Buyer Profile */}
          <div className="mgh-lsr-filter-group">
            <h4 className="mgh-lsr-filter-label">Buyer Type</h4>
            <div className="mgh-lsr-options-stack">
              <label className="mgh-lsr-check-row">
                <input
                  type="checkbox"
                  checked={onlyNRI}
                  onChange={() => setOnlyNRI(!onlyNRI)}
                />
                <span>NRI Buyers Only</span>
              </label>
            </div>
          </div>
        </aside>

        {/* Right Main Leads Results Column */}
        <section className="mgh-lsr-content">
          {/* Results Summary Bar */}
          <div className="mgh-lsr-results-bar">
            <div className="mgh-lsr-results-summary">
              <h2 className="mgh-lsr-results-count">
                Showing <span>{filteredLeads.length} Verified Leads</span> in{" "}
                {(activeSearch.searchArray || ["Hyderabad"]).join(", ")}
              </h2>
              <p className="mgh-lsr-results-sub">
                Connect directly with verified buyers and tenants actively seeking properties
              </p>
            </div>

            <div className="mgh-lsr-results-actions">
              {/* Mobile Filter Toggle */}
              <button
                type="button"
                className="mgh-lsr-mobile-filter-btn"
                onClick={() => setMobileFilterOpen(true)}
              >
                <FiSliders size={14} />
                <span>Filters {activeFiltersCount > 0 && `(${activeFiltersCount})`}</span>
              </button>

              {/* Modify Search Link */}
              <Link to="/leadtosearch" className="mgh-lsr-modify-btn">
                <FiArrowLeft size={14} />
                <span>Modify Search Form</span>
              </Link>
            </div>
          </div>

          {/* Leads Cards Grid */}
          <div className="mgh-lsr-cards-list">
            {loadingdata ? (
              <div className="mgh-lsr-loading-state">
                <div className="spinner-border text-warning" role="status">
                  <span className="visually-hidden">Loading Leads...</span>
                </div>
                <p style={{ margin: 0, fontWeight: "600", color: "#64748b" }}>
                  Searching verified leads in{" "}
                  {(activeSearch.searchArray || ["Hyderabad"]).join(", ")}...
                </p>
              </div>
            ) : filteredLeads.length === 0 ? (
              <div className="mgh-lsr-empty-state">
                <div className="mgh-lsr-empty-icon">
                  <FiUsers />
                </div>
                <h3 className="mgh-lsr-empty-title">No Matching Leads Found</h3>
                <p className="mgh-lsr-empty-desc">
                  Try broadening your bedrooms or locality filters to discover more active buyer leads in Hyderabad.
                </p>
                <button
                  type="button"
                  className="mgh-lsr-modify-btn"
                  onClick={resetAllFilters}
                >
                  <FiRotateCcw size={14} />
                  <span>Reset All Filters</span>
                </button>
              </div>
            ) : (
              filteredLeads.map((lead, index) => (
                <div className="mgh-lsr-card" key={lead._id || `lead-${index}`}>
                  {/* Card Top Row */}
                  <div className="mgh-lsr-card-top">
                    <div className="mgh-lsr-card-title-col">
                      <div className="mgh-lsr-card-title-row">
                        <h3 className="mgh-lsr-card-title">
                          {lead.propertyName || "Verified Residence Requirement"}
                        </h3>
                        <span className="mgh-lsr-verified-badge">
                          <FiCheckCircle size={12} /> Verified Buyer
                        </span>
                        <div className="mgh-lsr-stars">
                          <FaStar size={12} />
                          <FaStar size={12} />
                          <FaStar size={12} />
                          <FaStar size={12} />
                          <FaStarHalfAlt size={12} />
                          <span>5.0</span>
                        </div>
                      </div>
                      <div className="mgh-lsr-card-subinfo">
                        Buyer Inquiry for <strong>{lead.noofBedrooms || 3} BHK</strong> •{" "}
                        <strong>{lead.category || "Buy"}</strong> in{" "}
                        <strong>{lead.locality || lead.city || "Hyderabad"}</strong>
                      </div>
                    </div>

                    <span className="mgh-lsr-card-time">
                      <FiClock size={12} />
                      Received: {moment(lead.createdAt).format("Do MMM YYYY")}
                    </span>
                  </div>

                  {/* Card Key Metrics Grid */}
                  <div className="mgh-lsr-metrics-grid">
                    <div className="mgh-lsr-metric-box">
                      <span className="mgh-lsr-metric-label">Max Budget</span>
                      <span className="mgh-lsr-metric-val highlight">
                        {lead.price || "₹ 1.25 Cr"}
                      </span>
                    </div>

                    <div className="mgh-lsr-metric-box">
                      <span className="mgh-lsr-metric-label">Bedrooms</span>
                      <span className="mgh-lsr-metric-val">
                        {lead.noofBedrooms ? `${lead.noofBedrooms} BHK` : "3 BHK"}
                      </span>
                    </div>

                    <div className="mgh-lsr-metric-box">
                      <span className="mgh-lsr-metric-label">Possession</span>
                      <span className="mgh-lsr-metric-val">
                        {lead.possession || "Immediate"}
                      </span>
                    </div>

                    <div className="mgh-lsr-metric-box">
                      <span className="mgh-lsr-metric-label">Call Time</span>
                      <span className="mgh-lsr-metric-val">
                        {lead.callTime || "Any Time"}
                      </span>
                    </div>
                  </div>

                  {/* Buyer Masked Info Strip */}
                  <div className="mgh-lsr-buyer-strip">
                    <span>
                      Seeker: <strong>{lead.userName || lead.buyerName || "Verified Seeker"}</strong>
                    </span>
                    <span>
                      Locality: <strong>{lead.locality || "Hyderabad"}</strong>
                    </span>
                  </div>

                  {/* Card Footer Row */}
                  <div className="mgh-lsr-card-footer">
                    <div className="mgh-lsr-credit-cost">
                      <FiShield size={16} style={{ color: "#059669" }} />
                      <span>
                        Verified Buyer Contact: <strong>3.0 Credits</strong>
                      </span>
                    </div>

                    <div className="mgh-lsr-card-actions">
                      <button
                        type="button"
                        className="mgh-lsr-whatsapp-btn"
                        onClick={() => handleWhatsApp(lead)}
                        title="Chat with Buyer on WhatsApp"
                      >
                        <FaWhatsapp size={15} />
                        <span>WhatsApp</span>
                      </button>

                      <button
                        type="button"
                        className="mgh-lsr-contact-btn"
                        onClick={() => handleViewContact(lead)}
                      >
                        <FiPhoneCall size={14} />
                        <span>View Contact & Details</span>
                      </button>
                    </div>
                  </div>
                </div>
              ))
            )}
          </div>
        </section>
      </main>

      {/* ================= 3. Mobile Filter Drawer ================= */}
      {mobileFilterOpen && (
        <div
          className="mgh-lsr-drawer-overlay"
          onClick={() => setMobileFilterOpen(false)}
        >
          <div
            className="mgh-lsr-drawer-panel"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="mgh-lsr-drawer-top">
              <h3>Filter Leads</h3>
              <button
                type="button"
                className="mgh-lsr-drawer-close"
                onClick={() => setMobileFilterOpen(false)}
              >
                <FiX />
              </button>
            </div>

            {/* Bedrooms (BHK) Filter */}
            <div className="mgh-lsr-filter-group">
              <h4 className="mgh-lsr-filter-label">Bedrooms (BHK)</h4>
              <div className="mgh-lsr-pills-row">
                {[
                  { label: "All", val: "all" },
                  { label: "1 BHK", val: "1" },
                  { label: "2 BHK", val: "2" },
                  { label: "3 BHK", val: "3" },
                  { label: "4+ BHK", val: "4" },
                ].map((item) => (
                  <button
                    key={item.val}
                    type="button"
                    className={`mgh-lsr-choice-pill ${selectedBhk === item.val ? "active" : ""
                      }`}
                    onClick={() => setSelectedBhk(item.val)}
                  >
                    {item.label}
                  </button>
                ))}
              </div>
            </div>

            {/* Possession Timeline */}
            <div className="mgh-lsr-filter-group">
              <h4 className="mgh-lsr-filter-label">Possession Timeline</h4>
              <div className="mgh-lsr-options-stack">
                <label className="mgh-lsr-check-row">
                  <input
                    type="radio"
                    name="mobile_possession"
                    checked={possessionFilter === "all"}
                    onChange={() => setPossessionFilter("all")}
                  />
                  <span>All Timelines</span>
                </label>
                <label className="mgh-lsr-check-row">
                  <input
                    type="radio"
                    name="mobile_possession"
                    checked={possessionFilter === "immediate"}
                    onChange={() => setPossessionFilter("immediate")}
                  />
                  <span>Ready / Immediate</span>
                </label>
                <label className="mgh-lsr-check-row">
                  <input
                    type="radio"
                    name="mobile_possession"
                    checked={possessionFilter === "3months"}
                    onChange={() => setPossessionFilter("3months")}
                  />
                  <span>Within 3 Months</span>
                </label>
              </div>
            </div>

            {/* Buyer Profile */}
            <div className="mgh-lsr-filter-group">
              <h4 className="mgh-lsr-filter-label">Buyer Type</h4>
              <div className="mgh-lsr-options-stack">
                <label className="mgh-lsr-check-row">
                  <input
                    type="checkbox"
                    checked={onlyNRI}
                    onChange={() => setOnlyNRI(!onlyNRI)}
                  />
                  <span>NRI Buyers Only</span>
                </label>
              </div>
            </div>

            <button
              type="button"
              className="mgh-lsr-drawer-apply-btn"
              onClick={() => setMobileFilterOpen(false)}
            >
              Show {filteredLeads.length} Leads
            </button>
          </div>
        </div>
      )}

      {/* ================= 4. Property Details Modal ================= */}
      <Modal
        isOpen={modal2}
        toggle={toggle2}
        className="modalmainnew"
        centered
      >
        <div className="model-wrappernew">
          <ModalBody style={{ padding: 0 }}>
            {singleProperty && (
              <PropertyDetailsModel
                closePropdet={closePropDetailModal}
                propertyprop={singleProperty}
              />
            )}
          </ModalBody>
        </div>
      </Modal>

      {/* Auth Modals */}
      {modelShow && <Login />}

      {/* Website Standard Footer */}
      <Footer />
    </div>
  );
};

export default LeadsearchResult;
